<div *ngIf="showName === true || showName == null" [class.mat-subheading-1]="SmallDisplay" class="nobottommargin">
    {{ greeting }}, {{ username }}!
</div>
<div class="role" *ngIf="role && !user.RoleInfo.IsMultiRole">{{ role }}</div>
<div [hidden]="!role || !user.RoleInfo.IsMultiRole">
    <mat-menu #roleMenu="matMenu">
        <button mat-menu-item *ngIf="user && user.RoleInfo.IsSuperintendent" (click)="SwitchRole('Superintendent')">
            Superintendent Access
        </button>
        <button mat-menu-item *ngIf="user && user.RoleInfo.IsDeputySuperintendent" (click)="SwitchRole('DeputySuperintendent')">
            Deputy Superintendent Access
        </button>
        <button mat-menu-item *ngIf="user && user.RoleInfo.IsCabinet" (click)="SwitchRole('Cabinet')">Cabinet Access</button>
        <button mat-menu-item *ngIf="user && user.RoleInfo.IsBoardMember" (click)="SwitchRole('BoardMember')">
            Board Member Access
        </button>
        <button mat-menu-item *ngIf="user && user.RoleInfo.IsBoardAssistant" (click)="SwitchRole('BoardAssistant')">
            Board Assistant Access
        </button>
        <button mat-menu-item *ngIf="user && user.RoleInfo.IsFacilitator" (click)="SwitchRole('Facilitator')">
            Facilitator Access
        </button>
        <button mat-menu-item *ngIf="user && user.RoleInfo.IsResponder" (click)="SwitchRole('Responder')">Responder Access</button>
        <button mat-menu-item *ngIf="user && user.RoleInfo.IsDeveloper" (click)="SwitchRole('Developer')">Developer Access</button>
    </mat-menu>
    <button class="menutrigger" mat-raised-button color="primary" [matMenuTriggerFor]="roleMenu">
        <span>{{ role }}</span>
        <mat-icon>keyboard_arrow_down</mat-icon>
    </button>
</div>
